import React from 'react';
import { classNames } from 'react-extras';

export type ButtonProps = {
    children: any;
    variant?: string;
    size?: 'xsmall' | 'small' | 'medium' | 'large';
    href?: string | null;
    onClick?: () => void;
};

export const LrButton = (props: ButtonProps) => {
    const buttonClasses = classNames('Button', {
        [`Button--${props.variant}`]: props.variant,
        [`Button--${props.size}`]: props.size,
    });

    // TODO: Use PrismicLink instead of anchor tag
    const Tag: any = props.href ? 'a' : 'div';
    return (
        <Tag className={buttonClasses} href={props.href} onClick={props.onClick}>
            <div className="Button-wrapper">
                <div className="Button-text">{props.children}</div>
            </div>
        </Tag>
    );
};
